<template>
  <div>
    <GeneralDialog :visible.sync="showDialog" :visibleFooter="false" top="15vh" customClass="appleSolidPay" bodyPadding="0px">
      <template v-slot:header>
        <div class="title">{{ $t('deposit.applePay.payDetails') }}</div>
      </template>
      <template>
        <div class="desc_block">
          <div>
            <p>{{ $t('common.field.accNum') + ': ' + `${accountNum} - ${accountCurrency}` }}</p>
          </div>
          <div>
            <p>{{ $t('common.field.amt') + ': ' + amount }}</p>
          </div>
          <div class="form_button text-center">
            <form :action="solidPayments.shopperResultUrl" class="paymentWidgets" data-brands="APPLEPAY"></form>
          </div>
        </div>
      </template>

      <!-- <template>
        <div class="mt-10 dialog_content">
          <el-form>
            <el-form-item :label="$t('common.field.accNum')">
              <p>{{ `${accountNum} - ${accountCurrency}` }}</p>
            </el-form-item>
            <el-form-item :label="$t('common.field.amt')">
              <p>{{ amount }}</p>
            </el-form-item>
          </el-form>
        </div>
        <div class="form_button text-center">
          <form :action="solidPayments.shopperResultUrl" class="paymentWidgets" data-brands="APPLEPAY"></form>
        </div>
      </template> -->
    </GeneralDialog>
  </div>
</template>

<script>
import GeneralDialog from '@/components/home/vDialog';
export default {
  name: 'appleSolidpayDialog',
  components: { GeneralDialog },
  props: ['visible', 'accountNum', 'accountCurrency', 'amount', 'appleSolidPayData'],
  data() {
    return {
      showDialog: false,
      solidPayments: {
        shopperResultUrl: '',
        jsUrl: '',
        showAppleBtn: false
      }
    };
  },
  methods: {
    init() {
      const data = this.appleSolidPayData;
      this.solidPayments.shopperResultUrl = data.shopperResultUrl;
      this.solidPayments.jsUrl = data.jsUrl;
      this.insertApplePayJs(this.solidPayments.jsUrl);
      this.solidPayments.showAppleBtn = true;
      this.showDialog = this.visible;
    },
    insertApplePayJs(src) {
      const maxCounterLimit = 10;
      let counter = 1;
      let tag = document.createElement('script');
      tag.src = src;
      document.head.appendChild(tag);
      tag.onload = function () {
        let intervalID = setInterval(() => {
          if (counter === maxCounterLimit) clearInterval(intervalID);
          if (wpwlOptions) {
            wpwlOptions.applePay.onPaymentAuthorized = function (payment) {
              return {
                status: 'SUCCESS'
              };
            };
            wpwlOptions.onError = function (error) {
              // check if shopper payed after 30 minutes aka checkoutid is invalid
              if (error.name === 'InvalidCheckoutIdError') {
                //doSomething();
              } else if (error.name === 'WidgetError') {
                console.log('here we have extra properties: ');
                console.log(error.brand + ' and ' + error.event);
              }
              // read the error message
              console.log(error.message);
              console.log(error);
            };
            clearInterval(intervalID);
          }
          counter++;
        }, 1000);
      };
    }
  },
  watch: {
    showDialog(value) {
      this.$emit('update:visible', value);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.appleSolidPay /deep/.el-dialog {
  padding: 36px 20px;
}
.title {
  color: #232020;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.desc_block {
  text-align: center;
  > div {
    color: $PCS-main-text;
    font-size: 16px;
    padding-top: 20px;
    line-height: 20px;
  }
}
</style>
<style lang="scss">
.info_box_img {
  .img1 {
    position: absolute;
    right: 90px !important;
    top: 0;
  }

  .img2 {
    width: 78px;
    height: 58px;
    position: absolute;
    right: 0;
    top: 15px !important;
  }
}
</style>
